/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Refund_Policy_QuestionInputs */

const en_mobile_faq_refund_policy_question = /** @type {(inputs: Mobile_Faq_Refund_Policy_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund Policy`)
};

const es_mobile_faq_refund_policy_question = /** @type {(inputs: Mobile_Faq_Refund_Policy_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de reembolso`)
};

/**
* | output |
* | --- |
* | "Refund Policy" |
*
* @param {Mobile_Faq_Refund_Policy_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_refund_policy_question = /** @type {((inputs?: Mobile_Faq_Refund_Policy_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Refund_Policy_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_refund_policy_question(inputs)
	return en_mobile_faq_refund_policy_question(inputs)
});